import script from "./requestDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./requestDetails.vue?vue&type=script&setup=true&lang=js"

import "./requestDetails.vue?vue&type=style&index=0&id=3a01d80e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a01d80e"]])

export default __exports__